export default () => Math.round(Math.random() * Number.MAX_SAFE_INTEGER).toString(36);
